<template>
  <div ref="layoutInst" class="layout-free" v-if="layoutConfig" :style="styleObj" >
    <div ref="canvas" class="canvas" style="pointer-events:auto">
      <template v-for="(item, index) in layoutConfig.children">
        <Moveable v-if="canvas&&item.slotInfo" :key="index" :config="item.slotInfo" :isSlected="item===selectedComponent" 
        :container="$refs.canvas" :bounds="bounds()" @on-slot-resize="resize"
        :isEditing="isEditing" @save="save"
        :cellStep="cellStep">
          <slot :name="index">
            <h3>{{index+''}}</h3>
          </slot>
        </Moveable>
      </template>
    </div>
  </div>
</template>
<style lang="less" scoped>
.layout-free {
  position: relative;
  height: 100%;
  width: 100%;
  .canvas {
    // 这里很关键，使canvas宽高为0，并且z-index提升了其子元素的层级，最终达到可以被hover并且不会覆盖父元素的mask
    // position: absolute;
    // z-index: 2;
    height: 100%;
    width: 100%;
  }
}
</style>
<script>
import { ResizeObserver } from "vue-resize";
import Moveable from "./moveable";
export default {
  components: {
    Moveable,
    ResizeObserver
  },
  props: [
    'isEditing',
    'layoutConfig',
    'cellStep',
    'selectedComponent',
    'color',
    'image',
    'width',
    'height',
    'repeat',
  ],
  data() {
    return {
      canvas:null,
    };
  },

  mounted() {
    let me = this;
    this.canvas = this.$refs.canvas;
  },

  computed:{
    styleObj() {
      let style =  {
        backgroundColor: this.color||'#00000000',
      };
      if(this.image){
          style.backgroundImage = `URL('${this.image}')`;
          style.backgroundSize = `${this.width.value}${this.width.unit} ${this.height.value}${this.height.unit}`;
          style.backgroundRepeat = this.repeat;
      }
      return style;
    }
  },
  
  methods: {
    save(){
      this.$emit("save")
    },

    resize(){
      this.$emit("on-slot-resize");
    },
    bounds(){
      if(this.layoutConfig.slotInfo&&this.layoutConfig.slotInfo.position){
        return {
        left: 0,
        bottom: this.layoutConfig.slotInfo.position.height,
        top: 0,
        right: this.layoutConfig.slotInfo.position.width
        }
      }else{
        // console.log({
        //   left: 0,
        //   bottom: this.$el.offsetHeight,
        //   top: 0,
        //   right: this.$el.offsetWidth
        // });
        
        return {
          left: 0,
          bottom: this.$el.offsetHeight,
          top: 0,
          right: this.$el.offsetWidth
        }
      }
    },

    getSlotPosition(dropEvent, defaultSize){
      let position = {
        width: Math.round((defaultSize&&defaultSize.width)||this.$refs.layoutInst.clientWidth/4),
        height: Math.round((defaultSize&&defaultSize.height)||this.$refs.layoutInst.clientHeight/4),
        translateX: Math.round(dropEvent.offsetX),
        translateY: Math.round(dropEvent.offsetY),
        rotate: 0,
        scaleX: 1,
        scaleY: 1
      };
      return position;
    }
  }
};
</script>